import { useMemo } from 'react';
import { GoogleLogin, type CredentialResponse } from '@react-oauth/google';

type Props = {
  mode: 'login' | 'register';
  disabled?: boolean;
  onCredential: (idToken: string) => void;
  onError: (message: string) => void;
};

export function getGoogleOAuthClientId(): string {
  return (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
}

export function isGoogleAuthConfigured(): boolean {
  return Boolean(getGoogleOAuthClientId());
}

export default function GoogleAuthButton({ mode, disabled, onCredential, onError }: Props) {
  const clientId = getGoogleOAuthClientId();

  const buttonWidth = useMemo(() => {
    if (typeof window === 'undefined') {
      return 320;
    }
    return Math.min(400, Math.max(280, window.innerWidth - 80));
  }, []);

  if (!clientId) {
    return null;
  }

  const handleSuccess = (response: CredentialResponse) => {
    const idToken = response.credential;
    if (!idToken) {
      onError('Réponse Google incomplète. Réessayez.');
      return;
    }
    onCredential(idToken);
  };

  return (
    <div
      className={[
        'flex w-full justify-center overflow-hidden rounded-public-btn border border-outline-variant/25 bg-white',
        disabled ? 'pointer-events-none opacity-60' : '',
      ].join(' ')}
      aria-disabled={disabled}
    >
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => onError('Connexion Google annulée ou refusée.')}
        useOneTap={false}
        locale="fr"
        text={mode === 'register' ? 'signup_with' : 'signin_with'}
        shape="rectangular"
        theme="outline"
        size="large"
        width={buttonWidth}
        logo_alignment="left"
      />
    </div>
  );
}
